import styled from "styled-components";

const LoginProcessIBMStyled = styled.div`
.centered {
    width: 800px;
    border-radius: 5px;
    background: #101010;
    padding: 10px;
    height: 50px;
    position: absolute;
    margin-top: -25px;
    margin-left: -400px;
    top: 50%;
    left: 50%;
    border-radius: 50px;
}

p {
    color: #FFFFFF;
    text-align: center;
}
`

export default LoginProcessIBMStyled;
